import type { ConfigurationPackage } from '@festina/configuration-general-types/configuration'
import { Button } from '@festina-life/ui/actions'
import { Alert } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'

import { downloadConfigurationFile } from '../helpers'

type Props = {
  conflictChangesets: ConfigurationPackage
  sourceBranchName: string
  targetBranchName: string
  mergeConflictsWorkspaceName: string
}

export const MergeConflicts = ({
  conflictChangesets,
  sourceBranchName,
  targetBranchName,
  mergeConflictsWorkspaceName,
}: Props) => {
  const translate = useTranslate()

  return (
    <>
      <Alert
        severity="warning"
        title={translate(
          'branchDetailsPanel.tabs.manage.merge.conflictsChangeset.warning',
        )}
      />
      <div>
        <Button
          variant="discreet"
          className="p-0! mr-1 underline"
          onClick={() =>
            downloadConfigurationFile(
              conflictChangesets,
              `merge-${sourceBranchName}-to-${targetBranchName}-conflicts.json`,
            )
          }
        >
          {translate(
            'branchDetailsPanel.tabs.manage.merge.changesets.downloadButton',
          )}
        </Button>
        <span>
          {translate(
            'branchDetailsPanel.tabs.manage.merge.conflictsChangeset.text',
            {
              conflictsWorkspaceName: mergeConflictsWorkspaceName,
            },
          )}
        </span>
      </div>
    </>
  )
}
